import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { COMPLETE_STATUS, MODAL_PRIORITIES } from '~/contants/base';

const todoColor = {
  borderColor: '#166af0',
  backgroundColor: '#166af0',
};

const todoProcessingColor = {
  borderColor: '#adb3ba',
  backgroundColor: '#adb3ba',
};

const todoDoneColor = {
  borderColor: '#a9c1e8ff',
  backgroundColor: '#a9c1e8ff',
  classNames: 'todo-done-color'
};

const proposalColor = {
  borderColor: '#ccc',
  backgroundColor: 'rgba(0, 0, 0, 0.025)',
  textColor: '#666',
};

const todoNoOptionColor = {
  borderColor: 'transparent',
  backgroundColor: 'transparent',
};

export const getNeedShowProposalModal = (state) => state.needShowProposalModal;

export const getList = (state) => {
  let temp = JSON.parse(JSON.stringify(state.calendarList));
  let mstProcessingEvents = state.mstProcessingEvents;
  let listMstProposalIds = []

  temp = temp.map(item => {
    listMstProposalIds.push(item.mst_proposal_id);
    item.is_step = false;
    item.step_order = 0;
    if (item.steps.length > 1) {
      item.steps = item.steps.sort((a, b) => a.order - b.order);
    }
    return item;
  }).reduce((previousValue, currentValue, currentIndex) => {
    if (!currentValue.is_todo) {
      previousValue.push({
        ...currentValue,
        own_users: [],
        type_event: 'proposal',
      })
      return previousValue
    }

    const created_user_id = !currentValue.mst_proposal.created_by_ls 
      ? currentValue.mst_proposal.created_user_id
      : null

    const tmpProposal = {
      ...currentValue,
      type_event: 'todo',
      created_user_id
    }
    tmpProposal.own_users = getOwnUserIds(tmpProposal);

    previousValue.push(tmpProposal)

    if (currentValue.steps.length > 0) {
      for (let [index, step] of currentValue.steps.entries()) {
        if (step.start && step.end) {
          const tmpStep = {
            ...currentValue,
            id: step.id,
            start: step.start,
            end: step.end,
            is_step: true,
            is_task: false,
            item_order: index + 1,
            item: step,
            allDay: step.options.includes('all_day'),
            options: step.options,
            users_assign: step.users_assign,
            created_user_id: created_user_id,
            type_event: 'step',
            public: currentValue.public,
            todo: {
              id: currentValue.id,
              title: currentValue.title,
              start: currentValue.start,
              end: currentValue.end,
            },
            tasks: step.tasks ? step.tasks : []
          }
          tmpStep.own_users = getOwnUserIds(tmpStep);
          previousValue.push(tmpStep)

          if (step.tasks && step.tasks.length > 0) {
            for (let [index, task] of step.tasks.entries()) {
              if (task.start && task.end) {
                task.title = task.content.replace(/<\/?[^>]+(>|$)|&nbsp;/g, "")
                const tmpTask = {
                  ...currentValue,
                  id: task.id,
                  start: task.start,
                  end: task.end,
                  is_step: false,
                  is_task: true,
                  item_order: index + 1,
                  item: task,
                  allDay: task.options.includes('all_day'),
                  options: task.options,
                  users_assign: task.users_assign,
                  created_user_id: created_user_id,
                  type_event: 'task',
                  public: currentValue.public,
                  step: {
                    id: step.id,
                    title: step.title,
                    start: step.start,
                    end: step.end,
                  }
                }
                tmpTask.own_users = getOwnUserIds(tmpTask);
                previousValue.push(tmpTask)
              }
            }
          }
        }
      }
    }
    return previousValue;
  }, [])

  if (temp.length && mstProcessingEvents.length) {
    temp = temp.concat(mstProcessingEvents
      .filter(item => !listMstProposalIds.includes(item.id))
      .map(item => {
        return {
          ...item,
          type_event: 'todo',
          is_processing: true,
          own_users: [item.created_user_id]
        }
      })
    )
  }
  
  temp = temp.map(item => {
    const tmp = {
      start: item.start,
      end: item.end,
      title: item.title,
      id: item.id,
      type_event: item.type_event,
      own_users: item.own_users,
      public: item.public,
      extendedProps: {
        title: item.item ? item.item.title : item.title,
        start: item.start,
        end: item.end,
        is_todo: item.is_todo,
        is_step: item.is_step,
        is_task: item.is_task,
        item_order: item.item_order,
        manager_id: item.manager_id,
        created_user_id: item.created_user_id,
        status: item.item ? item.item.status : item.status,
        priority: item.priority,
        id_encrypt: item.id_encrypt,
        id: item.item ? item.item.id : item.id,
        options: item.options,
        isNoOptions: false,
        isRange: false,
        hasTime: true,
        progress: item.progress,
        step: item.steps ? item.steps : [],
        type_event: item.type_event,
        own_users: item.own_users,
        is_processing: item.is_processing,
      },
    };

    switch (tmp.extendedProps.type_event) {
      case 'step':
        tmp.extendedProps.todo = item.todo
        tmp.extendedProps.tasks = item.tasks
        break;
      case 'task':
        tmp.extendedProps.step = item.step
        break;
    }

    let startMoment = moment(item.start);
    let endMoment = moment(item.end);
    let startDay = startMoment.format('YYYY-MM-DD HH:mm:ss');
    let endDay = endMoment.format('YYYY-MM-DD HH:mm:ss');
    if (!isSameDay(startMoment, endMoment) && !item.allDay) {
      let tmpEndDay = cloneDeep(endMoment);
      if (tmpEndDay.format('HH:mm:ss') !== '00:00:00') {
        tmp.allDay = true;
      } else {
        endMoment = endMoment.add(-1, 'second');
        if (isSameDay(startMoment, tmpEndDay.add(-1, 'second'))) {
          tmp.allDay = false;
        } else {
          tmp.allDay = true;
        }
      }

      if (tmp.allDay) {
        endMoment = endMoment.add(1, 'day');
      }

      tmp.end = endMoment.format('YYYY-MM-DD HH:mm:ss')
    } else if (!isSameDay(startMoment, endMoment) && item.allDay) {
      endMoment = endMoment.add(1, 'second');
      tmp.end = endMoment.format('YYYY-MM-DD HH:mm:ss');
    }

    if (item.options.includes('all_day')) {
      startDay = endMoment.format('YYYY-MM-DD');
      endDay = endMoment.format('YYYY-MM-DD');
    }
    if (item.options.includes('all_day') && startDay === endDay) {
      tmp.allDay = true;
    }

    if (item.options.includes('all_day')) {
      tmp.hasTime = false;
    }

    if (item.is_todo && (
      !item.options.length ||
      (!item.options.includes('all_day') && startDay === endDay)
    )) {
      tmp.start = startDay;
      tmp.end = startDay;
      tmp.extendedProps.isNoOptions = true;
      Object.assign(tmp, todoNoOptionColor);
      Object.assign(tmp, item.status == COMPLETE_STATUS ? todoDoneColor : '');
      return tmp;
    }

    if (item.options.includes('split_date')) {
      tmp.extendedProps.isRange = true;
    }

    tmp.extendedProps.isOneDay = isSameDay(moment(tmp.start), moment(tmp.end));
    todoProcessingColor

    if (tmp.extendedProps.is_processing) {
      Object.assign(tmp, todoProcessingColor)
    } else {
      Object.assign(tmp, item.is_todo ? (item.status == COMPLETE_STATUS ? todoDoneColor : todoColor) : proposalColor);
    }

    return tmp;
  });

  return temp;
};

export const getListForModal = (state) => {
  const temp = JSON.parse(JSON.stringify(state.calendarList));

  return temp
    .filter(item => (
      moment(item.end).isBetween(moment(), moment().endOf('month'))
      && !item.is_todo
      && Object.keys(MODAL_PRIORITIES).includes(String(item.modal_priority))
    ))
    .sort((a, b) => a.modal_priority - b.modal_priority)
}

/**
 *
 * @param {moment.Moment} start
 * @param {moment.Moment} end
 * @private
 * @return boolean
 */
function isSameDay(start, end) {
  return start.format('YYYY-MM-DD') === end.format('YYYY-MM-DD')
}

/**
 * @param {*} event
 * @returns array
 */
function getOwnUserIds(event) {
  let ownUsers = []

  if (!event.is_todo) {
    return ownUsers
  }

  if (event.manager_id) {
    ownUsers.push(event.manager_id)
  } else if (event.created_user_id) {
    ownUsers.push(event.created_user_id)
  }

  if (event.users_assign && event.users_assign.length > 0) {
    event.users_assign.forEach(element => {
      ownUsers.push(element.id)
    })
  }

  return ownUsers
}
